import React from 'react';
import './DebugEndpoints.css';
import {Button} from "../../../components/FormZero/Button/Button";
import axios from "axios";
import {Stack} from "@mui/material";

export function DebugEndpoints (props) {
    const {} = props;

    const [result, setResult] = React.useState(undefined);
    const loadRoutes = async function() {
        try {
            // const result
            const response = await axios.get("logistic/routes");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    const loadLocations = async function() {
        try {
            // const result
            const response = await axios.get("logistic/locations");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    const loadDrivers = async function() {
        try {
            // const result
            const response = await axios.get("logistic/drivers");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    const loadTrucks = async function() {
        try {
            // const result
            const response = await axios.get("logistic/trucks");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    const loadDeliveries = async function() {
        try {
            // const result
            const response = await axios.get("logistic/deliveries");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    const loadLoads = async function() {
        try {
            // const result
            const response = await axios.get("logistic/loads");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    const loadPatchingLists = async function() {
        try {
            // const result
            const response = await axios.get("patching/patching-list");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    };

    // const loadPatchingTrays = async function() {
    //     try {
    //         // const result
    //         const response = await axios.get("patching/patching-list");
    //         setResult(response);
    //     }
    //     catch (e) {
    //         console.log(e);
    //         setResult(e);
    //     }
    // };

    const insertPatchingResult = async function() {
        try {
            // const result
            const response = await axios.post("patching/patching_results", {

            });
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    }

    const loadPatchingResult = async function() {
            try {
                // const result
                const response = await axios.get("patching/patching_results");
                setResult(response);
            }
            catch (e) {
                console.log(e);
                setResult(e);
            }
    }

    const loadGroups = async function() {
        try {
            // const result
            const response = await axios.get(`shared/groups/`);
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    }

    const loadUserWithGroups = async function() {
        try {
            // const result
            const response = await axios.get(`shared/grouped_users/1`);
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    }

    const insertUserGroup = async function() {
        try {
            // const result
            const response = await axios.post("shared/grouped_users/1/2");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    }

    const removeUserGroup = async function() {
        try {
            // const result
            const response = await axios.delete("shared/grouped_users/1/2");
            setResult(response);
        }
        catch (e) {
            console.log(e);
            setResult(e);
        }
    }

    return (
        <>
            <div className="DebugEndpoints">
                <h1>DebugEndpoints</h1>
                <Stack direction={"row"}>
                    {/*<Button clickHandler={() => { loadRoutes().then() }} text={"Get Routes"} />*/}
                    {/*<Button clickHandler={() => { loadLocations().then() }} text={"Get Locations"} />*/}
                    {/*<Button clickHandler={() => { loadDrivers().then() }} text={"Get Drivers"} />*/}
                    {/*<Button clickHandler={() => { loadTrucks().then() }} text={"Get Trucks"} />*/}
                    {/*<Button clickHandler={() => { loadDeliveries().then() }} text={"Get Deliveries"} />*/}
                    {/*<Button clickHandler={() => { loadLoads().then() }} text={"Get Loads"} />*/}
                    <Button clickHandler={() => { loadPatchingLists().then() }} text={"Get Patching Lists"} />
                    <Button clickHandler={() => { loadPatchingResult().then() }} text={"Get Patching Results"} />
                    <Button clickHandler={() => { loadUserWithGroups().then() }} text={"Get My user with group"} />
                    <Button clickHandler={() => { insertUserGroup().then() }} text={"create My user with group"} />
                    <Button clickHandler={() => { removeUserGroup().then() }} text={"remove My user with group"} />
                    <Button clickHandler={() => { loadGroups().then() }} text={"groups"} />
                </Stack>

                <pre style={{height: '500px', overflow: 'scroll'}}>{JSON.stringify(result, undefined, 4)}</pre>
            </div>
        </>
    )
}
